import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Navigate, Outlet } from '@tanstack/react-router';

import { Administrator } from '@/_providers/administration';

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  notFoundComponent: () => <Navigate to="/" />,
  component: () => {
    return (
      <Administrator>
        <Outlet />
        {/* {import.meta.env.DEV && <TanStackRouterDevtools initialIsOpen={false} />} */}
      </Administrator>
    );
  },
});

// const TanStackRouterDevtools = import.meta.env.PROD
//   ? () => null
//   : React.lazy(() =>
//       import('@tanstack/react-router-devtools').then((res) => ({
//         default: res.TanStackRouterDevtools,
//       }))
//     );
